module.exports = __webpack_public_path__ + "img/QRCode.ea486302.png";